import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import nextArrow from "../images/next-arrow.png";
import circlePrevArrow from "../images/circle-arrow-left.png";
import lastArrow from "../images/last-arrow.png";
import minusIcon from "../images/minus.png";
import plusIcon from "../images/plus.png";
import closeIcon from "../images/close.png";
import externalLinkIcon from "../images/link-white.png";
import lastThumbImage from "../images/last-slide.png";
import nextOfferIcon from "../images/next.png";
import nextOfferWhiteIconNew from "../images/arrow-forward-white-xxl.png";
import FALLBACK_IMAGE from "../images/tr-rectangle-placeholder.svg";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import SimilarOfferCard from "./SimilarOfferCard";
import {
  nextOfferAtom,
  similarOffersAtom,
  sliderBrochuresAtom,
  toggleSliderAtom,
  userLocationAtom,
  UUIDAtom,
} from "../Recoil/Atom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import NextOfferCard from "./NextOfferCard";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { post_user_tracking } from "../API/dataProvider";
import { Config, EventId, TrackingType } from "../config";
import { useLocation } from "react-router-dom";
import { ReturnScalledImg, ReturnScalledWidth } from "../helper";
import { v4 as uuidv4 } from "uuid";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function CarouselSlider() {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const [currSlideIndex, setCurrSlideIndex] = useState(1);
  const sliderBrochures = useRecoilValue(sliderBrochuresAtom);
  const setToggleSlider = useSetRecoilState(toggleSliderAtom);
  const similarOffers = useRecoilValue(similarOffersAtom);
  const nextOffer = useRecoilValue(nextOfferAtom);
  const navigate = useNavigate();
  const panZoom = useRef();
  const [isZoom, setIsZoom] = useState(0);
  let query = useQuery();
  const [hideMobileThumbnail, setHideMobileThumbnail] = useState(true);
  const userLocation = useRecoilValue(userLocationAtom);
  const UUID = useRecoilValue(UUIDAtom);
  const [paginationString, setPaginationString] = useState(
    sliderBrochures?.brochures[0]?.number +
      `${sliderBrochures?.brochures[1]?.number ? "-" + sliderBrochures?.brochures[1]?.number : ""}`
  );
  const [pixelTrackerDate, setPixelTrackerDate] = useState(Date.now());
  const [dynamicHeight, setDynamicHeight] = useState();

  const [page1, setPage1] = useState(sliderBrochures?.brochures[0]?.number ? sliderBrochures?.brochures[0]?.number : null);
  const [page2, setPage2] = useState(sliderBrochures?.brochures[1]?.number ? sliderBrochures?.brochures[1]?.number : null);
  let brochureId = Number(query.get("id"));

  const goToNextOffer = () => {
    post_user_tracking(
      TrackingType.BROCHURE_CLICK,
      nextOffer.offer_id,
      EventId.SHOW_NEXT_CARD,
      userLocation,
      undefined,
      UUID,
      window.location.href,
      undefined,
      undefined,
      uuidv4()
    );
    navigate(`${Config.brochure_route}?id=${nextOffer.offer_id}`, {
      replace: false,
    });
  };

  const closeSlider = () => {
    navigate(`${Config.brochure_route}`, { replace: false });
    setToggleSlider(false);
  };

  useEffect(() => {
    setFocus();
  });

  const setFocus = () => {
    let slider = document.querySelectorAll(".slick-track");
    slider[0]?.children[0]?.focus();
  };

  const nextSlideTracking = () => {
    nav1.slickNext();
    post_user_tracking(
      TrackingType.BROCHUREPAGE_VIEW,
      brochureId,
      EventId.NEXT_SLIDE,
      userLocation,
      currSlideIndex + 1,
      UUID,
      window.location.href,
      undefined,
      undefined,
      uuidv4()
    );
  };

  const previousSlideTracking = () => {
    nav1.slickPrev();

    post_user_tracking(
      TrackingType.BROCHUREPAGE_VIEW,
      brochureId,
      EventId.PREVIOUS_SLIDE,
      userLocation,
      currSlideIndex - 1,
      UUID,
      window.location.href,
      undefined,
      undefined,
      getUUIDbyPage(currSlideIndex - 1)
    );
  };

  useEffect(() => {
    post_user_tracking(
      TrackingType.BROCHURE_CLICK,
      sliderBrochures?.offer.offer_id,
      EventId.SHOW_OFFER_CARD,
      userLocation,
      undefined,
      UUID,
      window.location.href,
      undefined,
      undefined,
      uuidv4()
    );
    post_user_tracking(
      TrackingType.BROCHUREPAGE_VIEW,
      brochureId,
      EventId.PREVIOUS_SLIDE,
      userLocation,
      currSlideIndex ? currSlideIndex : 1,
      UUID,
      window.location.href,
      undefined,
      undefined,
      getUUIDbyPage(currSlideIndex ? currSlideIndex : 1)
    );
  }, []);

  const lastSlideTracking = () => {
    nav1.slickGoTo(!isMobile ? sliderBrochures?.brochures?.length - 1 : sliderBrochures?.brochures?.length);
    post_user_tracking(
      TrackingType.BROCHUREPAGE_VIEW,
      brochureId,
      EventId.LAST_SLIDE,
      userLocation,
      sliderBrochures?.brochures[sliderBrochures?.brochures?.length - 1]?.number,
      UUID,
      window.location.href,
      undefined,
      getUUIDbyPage(sliderBrochures?.brochures[sliderBrochures?.brochures?.length - 1]?.number)
    );
  };

  const clickOutTracking = (url, number) => {
    post_user_tracking(
      TrackingType.BROCHUREPAGE_CLICKOUT,
      brochureId,
      EventId.OUT_LINK_CLICK,
      userLocation,
      number,
      UUID,
      window.location.href,
      url,
      undefined,
      uuidv4()
    );
  };

  var init = 0;
  const setZoomState = () => {
    if (panZoom.current.state.scale === 1) {
      setIsZoom(false);
    } else {
      setIsZoom(true);
    }
    if (init === 0) {
      setIsZoom(true);
      init = 1;
    }
  };

  const useWindowDimensions = () => {
    const hasWindow = typeof window !== "undefined";

    function getWindowDimensions() {
      const width = hasWindow ? window.innerWidth : null;
      const height = hasWindow ? window.innerHeight : null;
      return {
        width,
        height,
      };
    }

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
      if (hasWindow) {
        function handleResize() {
          setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }
    }, [hasWindow]);
    return windowDimensions;
  };

  const onZoomEvent = () => {
    if (panZoom?.current?.state?.scale <= 1) {
      panZoom?.current?.resetTransform(100);
      setIsZoom(false);
    } else {
      setIsZoom(true);
    }
  };
  const [timer, setTimer] = useState({
    1: Date.now(),
    2: Date.now(),
  });

  const [prevFrameState, setPrevFrameState] = useState([1, 2]);
  function arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele != value;
    });
  }

  const getUUIDbyPage = (page) => {
    return sliderBrochures?.brochures.filter((a) => a.number === page)[0]?.track_UUID;
  };

  useEffect(() => {
    let callEventForPage = prevFrameState;
    callEventForPage = arrayRemove(callEventForPage, page1);
    callEventForPage = arrayRemove(callEventForPage, page2);
    callEventForPage.forEach((data) => {
      post_user_tracking(
        TrackingType.BROCHUREPAGE_DURATION,
        brochureId,
        undefined,
        userLocation,
        data,
        UUID,
        window.location.href,
        undefined,
        undefined,
        uuidv4(),
        Number(Number((Date.now() / 1000 - timer[data] / 1000) / 2).toFixed()),
        getUUIDbyPage(data)
      );
      let tmp = timer;
      tmp[page1] = timer[page1] ? timer[page1] : Date.now();
      tmp[page2] = timer[page2] ? timer[page2] : Date.now();
      delete tmp[data];
      setTimer(tmp);
    });
    setPrevFrameState([page1, page2]);
  }, [page1, page2]);

  const slideChangeEvent = (e) => {
    setPage1(sliderBrochures?.brochures[e]?.number ? sliderBrochures?.brochures[e]?.number : null);
    setPage2(sliderBrochures?.brochures[e + 1]?.number ? sliderBrochures?.brochures[e + 1]?.number : null);
    setCurrSlideIndex(
      nav2?.innerSlider?.asNavForIndex
        ? sliderBrochures?.brochures[e]?.number
          ? sliderBrochures?.brochures[e]?.number
          : sliderBrochures?.brochures?.length + 1
        : 1
    );
    if (sliderBrochures?.brochures[e + 1]?.number) {
      setPaginationString(sliderBrochures?.brochures[e].number + "-" + sliderBrochures?.brochures[e + 1].number);
    } else {
      setPaginationString(sliderBrochures?.brochures.length);
    }
  };

  const { width } = useWindowDimensions();
  const mobScreen = 767;
  const isMobile = width <= mobScreen;

  const [dynamicBrochureContainerWidth, setDynamicBrochureContainerWidth] = useState(0);
  const [thumbnailHeight, setThumbnailHeight] = useState(0);
  var finalImgHeight = window.innerHeight - thumbnailHeight - 80;

  useEffect(() => {
    if (width > 768) {
      setDynamicHeight(finalImgHeight);
      setDynamicBrochureContainerWidth(ReturnScalledWidth(sliderBrochures?.brochures[0]?.image, finalImgHeight));
    }
  }, [width, finalImgHeight, window.innerHeight, window.innerWidth, thumbnailHeight]);

  return (
    <div className="relative h-full">
      {sliderBrochures?.brochures ? (
        <>
          <div id="brochures-wrapper">
            <div className="max-w-[1200px] mx-auto">
              {isMobile ? (
                hideMobileThumbnail ? (
                  <button
                    className="absolute z-10 flex items-center justify-center w-5 h-5 text-sm bg-white rounded-full md:w-10 md:h-10 text-dark top-5 right-5"
                    onClick={() => {
                      closeSlider();
                    }}
                  >
                    <img src={closeIcon} className="max-h-2 md:max-h-4" alt="close icon" />
                  </button>
                ) : null
              ) : (
                <button
                  className="absolute z-10 flex items-center justify-center w-5 h-5 text-sm bg-white rounded-full md:w-10 md:h-10 text-dark top-5 right-5"
                  onClick={() => {
                    closeSlider();
                  }}
                >
                  <img src={closeIcon} className="max-h-2 md:max-h-4" alt="close icon" />
                </button>
              )}

              <button
                id="prevButton"
                className={`shadow-lg rounded-full hidden md:block absolute left-[5%] xl:left-[20%] transform -translate-y-1/2 top-[calc(50%-50px)] z-[1]`}
                onClick={() => previousSlideTracking()}
              >
                <img src={circlePrevArrow} className="w-5 h-5 md:w-10 md:h-10" alt="prev slide button" />
              </button>

              {sliderBrochures?.brochures?.length === currSlideIndex || sliderBrochures?.brochures?.length === 0 ? (
                <button
                  className="shadow-lg rounded-full hidden w-5 h-5 md:h-10 md:w-10 bg-white rounded-full md:flex items-center justify-center absolute transform -translate-y-1/2 right-[20%] top-[calc(50%-50px)] z-[1]"
                  onClick={() => goToNextOffer()}
                >
                  <img className="max-h-4" src={nextOfferIcon} alt="next slide button" />
                </button>
              ) : (
                <button
                  id="nextButton"
                  className="shadow-lg rounded-full hidden w-5 h-5 md:h-10 md:w-10 rounded-full md:flex items-center justify-center absolute transform -translate-y-1/2 right-[5%] xl:right-[20%] top-[calc(50%-50px)] z-[1]"
                  onClick={() => nextSlideTracking()}
                >
                  <img
                    className="w-5 h-5 transform rotate-180 md:w-10 md:h-10 rotate"
                    src={circlePrevArrow}
                    alt="next slide button"
                  />
                </button>
              )}
            </div>
            <div
              // className={`mb-10 mx-auto
              // ${
              //   (sliderBrochures?.brochures?.length === currSlideIndex) | (sliderBrochures?.brochures?.length === 0)
              //     ? "max-w-[1200px]1 lg:max-w-[40%] 3xl:max-w-[44%]"
              //     : "lg:max-w-[40%] 3xl:max-w-[44%]"
              // }`}
              style={{
                maxWidth: width > 768 ? dynamicBrochureContainerWidth * 2 : "100%",
              }}
              className={`mb-10 mx-auto mainSliderWrapper px-4`}
            >
              <Slider
                asNavFor={nav2}
                ref={(slider1) => setNav1(slider1)}
                infinite={false}
                swipeToSlide={true}
                draggable={false}
                afterChange={(e) => slideChangeEvent(e)}
                beforeChange={(e) => slideChangeEvent(e)}
                slidesToShow={2}
                responsive={[
                  {
                    breakpoint: 1024,
                    settings: {
                      swipeToSlide: true,
                    },
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      slidesToShow: 1,
                      swipeToSlide: true,
                    },
                  },
                ]}
              >
                {sliderBrochures?.brochures
                  ? sliderBrochures?.brochures?.map((item, index) => {
                      return (
                        <div
                          className={` ${
                            isMobile && !hideMobileThumbnail ? "" : "mt-12"
                          } md:mt-20 relative !flex items-center justify-center slick-slide`}
                          key={index}
                        >
                          <div className="lg:h-[66vh]1 lg:w-[22vw]1">
                            <TransformWrapper
                              ref={panZoom}
                              scale={1}
                              defaultScale={1}
                              onZoomStop={(e) => {
                                if (e.state.scale <= 1) {
                                  panZoom.current.resetTransform(100);
                                  setIsZoom(false);
                                } else {
                                  setIsZoom(true);
                                }
                              }}
                              maxScale={4}
                              minScale={1}
                              panning={{ disabled: !isZoom }}
                            >
                              {({ zoomIn, zoomOut, resetTransform, state }) => (
                                <>
                                  {onZoomEvent()}
                                  {isMobile ? (
                                    hideMobileThumbnail ? (
                                      <div className="absolute left-0 right-0 text-center divide-x -top-[38px] md:top-[-60px] divide divide-[#e5e5e5] min-w-[75px]">
                                        <button
                                          className="px-2 py-2 text-xl font-semibold transition-all duration-300 bg-white rounded-tl-full rounded-bl-full md:px-3 md:py-3 text-dark hover:bg-gray-200"
                                          onClick={() => {
                                            setZoomState();
                                            zoomOut();
                                          }}
                                        >
                                          <img className="max-h-2 md:max-h-3" src={minusIcon} alt="minus icon" />
                                        </button>
                                        <button
                                          className="px-2 py-2 text-xl font-semibold transition-all duration-300 bg-white rounded-tr-full rounded-br-full md:px-3 md:py-3 text-dark hover:bg-gray-200"
                                          onClick={() => {
                                            setZoomState();
                                            zoomIn();
                                          }}
                                        >
                                          <img className="max-h-2 md:max-h-3" src={plusIcon} alt="plus icon" />
                                        </button>
                                      </div>
                                    ) : null
                                  ) : (
                                    <div className="absolute left-0 right-0 text-center divide-x -top-[38px] md:top-[-60px] divide divide-[#e5e5e5] min-w-[75px]">
                                      <button
                                        className="px-2 py-2 text-xl font-semibold transition-all duration-300 bg-white rounded-tl-full rounded-bl-full md:px-3 md:py-3 text-dark hover:bg-gray-200"
                                        onClick={() => {
                                          setZoomState();
                                          zoomOut();
                                        }}
                                      >
                                        <img className="max-h-2 md:max-h-3" src={minusIcon} alt="minus icon" />
                                      </button>
                                      <button
                                        className="px-2 py-2 text-xl font-semibold transition-all duration-300 bg-white rounded-tr-full rounded-br-full md:px-3 md:py-3 text-dark hover:bg-gray-200"
                                        onClick={() => {
                                          setZoomState();
                                          zoomIn();
                                        }}
                                      >
                                        <img className="max-h-2 md:max-h-3" src={plusIcon} alt="plus icon" />
                                      </button>
                                    </div>
                                  )}
                                  <TransformComponent className="relative">
                                    <div
                                      onClick={() => {
                                        setHideMobileThumbnail(!hideMobileThumbnail);
                                      }}
                                    >
                                      <div
                                        className={`relative1 items-center justify-center flex ${
                                          isMobile ? (hideMobileThumbnail ? "" : "min-h-[calc(100vh-3.5rem)]") : ""
                                        }`}
                                      >
                                        <div className="absolute z-[-1] w-full h-full flex items-center justify-center">
                                          <svg
                                            className="max-h-3 md:max-h-6 animate-spin"
                                            fill="#ffffff"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                          >
                                            <path d="M14 22c0 1.104-.896 2-2 2s-2-.896-2-2 .896-2 2-2 2 .896 2 2zm-2-22c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm10 10c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm-20.001 1c.551 0 1.001.449 1.001 1 0 .551-.449 1-1 1s-1-.448-1-1 .448-1 .999-1zm.002-1h-.002c-1.104 0-1.999.896-1.999 2 0 1.105.896 2 2 2h.001c1.104 0 1.999-.896 1.999-2s-.895-2-1.999-2zm16.999-7c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm0 14c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm-14-13c.551 0 1 .448 1 1s-.449 1-1.001 1c-.551 0-.999-.448-.999-1s.449-1 1-1zm-.001-1c-1.104 0-1.999.896-1.999 2s.896 2 1.999 2h.001c1.104 0 2-.896 2-2s-.896-2-2.001-2zm.001 15c.551 0 1 .448 1 1s-.449 1-1.001 1c-.551 0-.999-.448-.999-1s.449-1 1-1zm-.001-1c-1.104 0-1.999.896-1.999 2s.896 2 1.999 2h.001c1.104 0 2-.896 2-2s-.896-2-2.001-2z" />
                                          </svg>
                                        </div>
                                        <div className="relative">
                                          {item?.links?.map((e, i) => {
                                            return (
                                              <div key={i}>
                                                <div
                                                  className="link-pointer"
                                                  style={{
                                                    height: `32px`,
                                                    width: `32px`,
                                                    left: `${e.left * 100}%`,
                                                    top: `${e.top * 100}%`,
                                                    position: "absolute",
                                                    background: "#2A65B7",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "6px",
                                                    padding: "5px",
                                                    zIndex: 9999,
                                                    boxShadow: "0px 3px 6px rgba(42, 101, 183, 0.3)",
                                                  }}
                                                >
                                                  <a
                                                    className="transition-all duration-300 transform hover:scale-125"
                                                    key={i}
                                                    href={e.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={() => clickOutTracking(e.url, item.number)}
                                                  >
                                                    <img
                                                      style={{ maxHeight: 16 }}
                                                      src={externalLinkIcon}
                                                      alt="external link icon"
                                                    />
                                                  </a>
                                                </div>
                                              </div>
                                            );
                                          })}

                                          <LazyLoadImage
                                            className={`sliderSlide ${
                                              isMobile && !hideMobileThumbnail ? "" : "h-[calc(100vh-200px)]1"
                                            } h-auto m-auto md:object-[initial]`}
                                            src={item.image ? item.image : FALLBACK_IMAGE}
                                            // src={item.image}
                                            alt={item.title}
                                            loading="lazy"
                                            effect="blur"
                                            delayMethod={"debounce"}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </TransformComponent>
                                </>
                              )}
                            </TransformWrapper>
                          </div>
                        </div>
                      );
                    })
                  : null}

                <div
                  className={`!block mt-12 max-w-[1200px] px-4 mx-auto ${
                    isMobile ? "h-[calc(100vh-180px)]" : ``
                  } overflow-y-scroll  pt-[25px]`}
                >
                  <div className="space-y-4" style={!isMobile ? { height: dynamicHeight + 10 } : null}>
                    {nextOffer ? (
                      <div>
                        <h2 className="mb-3 font-bold text-white sm:text-xl md:text-2xl">Nächster Prospekt</h2>
                        <NextOfferCard item={nextOffer} />
                      </div>
                    ) : null}
                    {similarOffers?.length ? (
                      <div>
                        <h2 className="mb-3 font-bold text-white sm:text-xl md:text-2xl">Ähnliche Prospekte</h2>
                        <div className="!grid grid-cols-2 sm:grid-cols-2 gap-4">
                          {similarOffers?.map((item, index) => {
                            return <SimilarOfferCard key={index} item={item} />;
                          })}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </Slider>
            </div>
          </div>
          <div
            className={` ${
              isMobile && !hideMobileThumbnail ? "hidden" : ""
            } absolute w-full bottom-0 py-4 md:py-[1.5%] bg-gradient-to-b from-[rgba(38,48,61,0.4)] to-dark bg-opacity-50`}
            id="brochureThumbnailSliderWrapper"
            onLoad={(e) => {
              setThumbnailHeight(e.currentTarget.clientHeight);
            }}
          >
            <div id="brochureThumbnailSlider" className="md:mb-2">
              <Slider
                asNavFor={nav1}
                ref={(slider2) => setNav2(slider2)}
                swipeToSlide={true}
                // slidesToShow={15}
                centerMode={true}
                focusOnSelect={true}
                infinite={false}
                draggable={false}
                padding={10}
                variableWidth={true}
                responsive={[
                  {
                    breakpoint: 1600,
                    settings: {
                      variableWidth: false,
                      slidesToShow: 15,
                    },
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 10,
                      swipeToSlide: true,
                      variableWidth: false,
                      centerMode: false,
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 8,
                      swipeToSlide: true,
                      variableWidth: false,
                      centerMode: false,
                    },
                  },
                  {
                    breakpoint: 640,
                    settings: {
                      slidesToShow: 6,
                      swipeToSlide: true,
                      variableWidth: false,
                      centerMode: false,
                    },
                  },
                  {
                    breakpoint: 450,
                    settings: {
                      slidesToShow: 5,
                      swipeToSlide: true,
                      variableWidth: false,
                      centerMode: false,
                    },
                  },
                ]}
              >
                {sliderBrochures?.brochures
                  ? sliderBrochures?.brochures?.map((item, index) => {
                      return (
                        <div key={index}>
                          <div className="relative min-w-[40px] h-[70px] md:h-[100px] 2xl:h-[120px] pr-3 slick-slide" key={index}>
                            <div className="min-w-[40px] mt-3 absolute z-[-1] w-full flex items-center justify-center">
                              <svg
                                className="max-h-3 md:max-h-6 animate-spin"
                                fill="#ffffff"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                              >
                                <path d="M14 22c0 1.104-.896 2-2 2s-2-.896-2-2 .896-2 2-2 2 .896 2 2zm-2-22c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm10 10c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm-20.001 1c.551 0 1.001.449 1.001 1 0 .551-.449 1-1 1s-1-.448-1-1 .448-1 .999-1zm.002-1h-.002c-1.104 0-1.999.896-1.999 2 0 1.105.896 2 2 2h.001c1.104 0 1.999-.896 1.999-2s-.895-2-1.999-2zm16.999-7c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm0 14c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm-14-13c.551 0 1 .448 1 1s-.449 1-1.001 1c-.551 0-.999-.448-.999-1s.449-1 1-1zm-.001-1c-1.104 0-1.999.896-1.999 2s.896 2 1.999 2h.001c1.104 0 2-.896 2-2s-.896-2-2.001-2zm.001 15c.551 0 1 .448 1 1s-.449 1-1.001 1c-.551 0-.999-.448-.999-1s.449-1 1-1zm-.001-1c-1.104 0-1.999.896-1.999 2s.896 2 1.999 2h.001c1.104 0 2-.896 2-2s-.896-2-2.001-2z" />
                              </svg>
                            </div>
                            <LazyLoadImage
                              className="innerSliderSlide max-h-[70px] md:max-h-[100px] 2xl:max-h-[120px] w-auto"
                              src={item.image ? ReturnScalledImg(item.image) : FALLBACK_IMAGE}
                              alt={item.title}
                              loading="lazy"
                              effect="blur"
                              delayMethod={"debounce"}
                            />
                          </div>
                        </div>
                      );
                    })
                  : null}
                {/* last slide thumb image */}
                {sliderBrochures?.brochures?.length === 0 ? null : (
                  <div className="!block md:!hidden">
                    <img className="h-[70px]  md:h-[100px] w-auto" src={lastThumbImage} alt="lastSlide thumb" />
                  </div>
                )}
              </Slider>
            </div>
            {/* Desktop thumb slider buttons */}
            <div className="items-center justify-center hidden space-x-3 md:flex">
              {sliderBrochures?.brochures?.length === 0 ? null : (
                <button
                  onClick={() => {
                    nav1.slickGoTo(0);
                  }}
                  className={`mt-[3px] ${currSlideIndex === 1 ? "opacity-50  pointer-events-none" : ""}`}
                >
                  <img className="transform rotate-180 rotate max-h-4" src={lastArrow} alt="first slide button" />
                </button>
              )}

              {sliderBrochures?.brochures?.length === 0 ? null : (
                <button
                  onClick={() => previousSlideTracking()}
                  className={`mt-[3px] ${currSlideIndex === 1 ? "opacity-50  pointer-events-none" : ""}`}
                >
                  <img src={nextArrow} className="transform rotate-180 rotate max-h-4" alt="prev slide button" />
                </button>
              )}
              {sliderBrochures?.brochures?.length > 0 ? (
                <div className="text-sm mt-[-1px]">
                  <span>{paginationString}</span>
                  <span> / </span>
                  <span>{Number(sliderBrochures?.brochures?.length)}</span>
                </div>
              ) : null}
              {sliderBrochures?.brochures?.length === currSlideIndex || sliderBrochures?.brochures?.length === 0 ? (
                <button onClick={() => goToNextOffer()}>
                  <img className="max-h-4" src={nextOfferWhiteIconNew} alt="next offer button" />
                </button>
              ) : (
                <button onClick={() => nextSlideTracking()}>
                  <img className="max-h-4" src={nextArrow} alt="next slide button" />
                </button>
              )}
              {sliderBrochures?.brochures?.length !== 0 ? (
                <button
                  className={`${sliderBrochures?.brochures?.length === currSlideIndex ? "opacity-50  pointer-events-none" : ""}`}
                  onClick={() => {
                    lastSlideTracking();
                  }}
                >
                  <img className="max-h-4" src={lastArrow} alt="last slide button" />
                </button>
              ) : null}
            </div>

            {/* Mobile thumb slider buttons */}

            <div className="flex items-center justify-center space-x-3 text-xs md:hidden">
              {sliderBrochures?.brochures?.length === 0 ? null : (
                <button
                  onClick={() => {
                    nav1.slickGoTo(0);
                  }}
                  className={`${currSlideIndex === 1 ? "opacity-50  pointer-events-none" : ""}`}
                >
                  <img className="transform rotate-180 rotate max-h-3" src={lastArrow} alt="first slide button" />
                </button>
              )}

              {sliderBrochures?.brochures?.length === 0 ? null : (
                <button
                  onClick={() => previousSlideTracking()}
                  className={`${currSlideIndex === 1 ? "opacity-50  pointer-events-none" : ""}`}
                >
                  <img src={nextArrow} className="transform rotate-180 rotate max-h-3" alt="prev slide button" />
                </button>
              )}

              {sliderBrochures?.brochures?.length > 0 ? (
                <div>
                  <span>{currSlideIndex}</span>
                  <span> / </span>
                  <span>{Number(sliderBrochures?.brochures?.length + 1)}</span>
                </div>
              ) : null}

              {sliderBrochures?.brochures?.length + 1 == currSlideIndex || sliderBrochures?.brochures?.length === 0 ? (
                <button
                  onClick={() => {
                    goToNextOffer();
                  }}
                >
                  <img className="max-h-3" src={nextOfferWhiteIconNew} alt="next offer button" />
                </button>
              ) : (
                <button onClick={() => nextSlideTracking()}>
                  <img className="max-h-3" src={nextArrow} alt="next slide button" />
                </button>
              )}

              {sliderBrochures?.brochures?.length !== 0 ? (
                <button
                  className={`${
                    sliderBrochures?.brochures?.length + 1 === currSlideIndex ? "opacity-50  pointer-events-none" : ""
                  }`}
                  onClick={() => {
                    lastSlideTracking();
                  }}
                >
                  <img className="max-h-3" src={lastArrow} alt="last slide button" />
                </button>
              ) : null}
            </div>
          </div>
        </>
      ) : null}

      {sliderBrochures?.offer?.tracking_bugs?.map((item) => {
        return (
          <>
            <img id="CACHEBUSTER" src={item.replace("%%CACHEBUSTER%%", pixelTrackerDate)} alt="" />
            {/* <iframe src={item.replace("%%CACHEBUSTER%%", Date.now())}></iframe> */}
          </>
        );
      })}
    </div>
  );
}

export default CarouselSlider;
